import React from "react";
import styles from "./statusgame.module.css";

function StatusGame({ children, status }) {
  return (
    <div>
      {status === "Pass" && (
        <div className={styles.body}>
          <div className={styles.textPass}>{children}</div>
        </div>
      )}
      {status === "Fail" && (
        <div className={styles.body}>
          <div className={styles.textFailed}>{children}</div>
        </div>
      )}
      {status === "Success" && (
        <div className={styles.body}>
          <div className={styles.textSuccess}>{children}</div>
        </div>
      )}
    </div>
  );
}

export default StatusGame;
